// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pd-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  animation: pdFadeIn 0.25s ease;
}

.pd-modal {
  position: relative;
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 1.25rem;
  border: 1px solid #E2E8F0;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 2rem;
  animation: pdSlideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.pd-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  border-radius: 0.5rem;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pd-close:hover {
  background: #FEF2F2;
  border-color: #FECACA;
  color: #DC2626;
}

.pd-icon-wrap {
  width: 58px;
  height: 58px;
  margin: 0 auto 1rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);
  color: #0F766E;
  border: 1px solid #99F6E4;
}

.pd-title {
  text-align: center;
  font-size: 1.375rem;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.3px;
  margin-bottom: 0.5rem;
}

.pd-sub {
  text-align: center;
  font-size: 0.875rem;
  color: #64748B;
  line-height: 1.55;
  margin-bottom: 1.5rem;
}

.pd-field {
  display: block;
  margin-bottom: 1.1rem;
}

.pd-label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 0.45rem;
}

.pd-input-wrap {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.65rem 0.9rem;
  background: #F8FAFC;
  border: 1.5px solid #E2E8F0;
  border-radius: 0.65rem;
  transition: border-color 0.2s, background 0.2s;
}

.pd-input-wrap:focus-within {
  border-color: #0F766E;
  background: #fff;
}

.pd-input-icon {
  color: #94A3B8;
  flex-shrink: 0;
}

.pd-input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-size: 0.9375rem;
  color: #0F172A;
  font-family: inherit;
}

.pd-input::placeholder {
  color: #CBD5E1;
}

.pd-input-wrap.pd-input-error {
  border-color: #F87171;
  background: #FFF7F7;
}

.pd-error {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  color: #DC2626;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.35rem;
}

.pd-continue {
  width: 100%;
  margin-top: 0.75rem;
  padding: 0.8rem 1rem;
  background: linear-gradient(135deg, #0F766E, #0D9488);
  color: #fff;
  border: none;
  border-radius: 0.75rem;
  font-family: inherit;
  font-size: 0.9375rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);
  transition: opacity 0.2s, transform 0.15s;
}

.pd-continue:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

@keyframes pdFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes pdSlideUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/component/PatientDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iDAAiD;EACjD,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":[".pd-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1.5rem;\r\n  animation: pdFadeIn 0.25s ease;\r\n}\r\n\r\n.pd-modal {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 420px;\r\n  background: #fff;\r\n  border-radius: 1.25rem;\r\n  border: 1px solid #E2E8F0;\r\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n  padding: 2rem;\r\n  animation: pdSlideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.pd-close {\r\n  position: absolute;\r\n  top: 0.75rem;\r\n  right: 0.75rem;\r\n  width: 34px;\r\n  height: 34px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #F1F5F9;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.5rem;\r\n  color: #64748B;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.pd-close:hover {\r\n  background: #FEF2F2;\r\n  border-color: #FECACA;\r\n  color: #DC2626;\r\n}\r\n\r\n.pd-icon-wrap {\r\n  width: 58px;\r\n  height: 58px;\r\n  margin: 0 auto 1rem;\r\n  border-radius: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);\r\n  color: #0F766E;\r\n  border: 1px solid #99F6E4;\r\n}\r\n\r\n.pd-title {\r\n  text-align: center;\r\n  font-size: 1.375rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  letter-spacing: -0.3px;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.pd-sub {\r\n  text-align: center;\r\n  font-size: 0.875rem;\r\n  color: #64748B;\r\n  line-height: 1.55;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.pd-field {\r\n  display: block;\r\n  margin-bottom: 1.1rem;\r\n}\r\n\r\n.pd-label {\r\n  display: block;\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  color: #334155;\r\n  margin-bottom: 0.45rem;\r\n}\r\n\r\n.pd-input-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  padding: 0.65rem 0.9rem;\r\n  background: #F8FAFC;\r\n  border: 1.5px solid #E2E8F0;\r\n  border-radius: 0.65rem;\r\n  transition: border-color 0.2s, background 0.2s;\r\n}\r\n\r\n.pd-input-wrap:focus-within {\r\n  border-color: #0F766E;\r\n  background: #fff;\r\n}\r\n\r\n.pd-input-icon {\r\n  color: #94A3B8;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.pd-input {\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  width: 100%;\r\n  font-size: 0.9375rem;\r\n  color: #0F172A;\r\n  font-family: inherit;\r\n}\r\n\r\n.pd-input::placeholder {\r\n  color: #CBD5E1;\r\n}\r\n\r\n.pd-input-wrap.pd-input-error {\r\n  border-color: #F87171;\r\n  background: #FFF7F7;\r\n}\r\n\r\n.pd-error {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  color: #DC2626;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  margin-top: 0.35rem;\r\n}\r\n\r\n.pd-continue {\r\n  width: 100%;\r\n  margin-top: 0.75rem;\r\n  padding: 0.8rem 1rem;\r\n  background: linear-gradient(135deg, #0F766E, #0D9488);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 0.75rem;\r\n  font-family: inherit;\r\n  font-size: 0.9375rem;\r\n  font-weight: 700;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);\r\n  transition: opacity 0.2s, transform 0.15s;\r\n}\r\n\r\n.pd-continue:hover {\r\n  opacity: 0.92;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n@keyframes pdFadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes pdSlideUp {\r\n  from { opacity: 0; transform: translateY(16px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
